"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SlidingPanelSection = exports.SlidingPanelHeader = exports.ToggleIcon = exports.SlidingPanelDropdown = exports.slidingPanelDropdownStateToProps = exports.InternalSlidingPanelDropdown = exports.InternalToggleIcon = exports.SlidingPanel = exports.slidingPanelStateToProps = exports.InternalSlidingPanel = exports.slidingPanelActiveLens = exports.slidingPanelLens = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var R = __importStar(require("ramda"));
var react_redux_1 = require("react-redux");
var SlidingPanel_1 = require("@cjdev-internal/visual-stack/lib/components/SlidingPanel");
var actions_1 = require("../actions");
var useFirstDefinedValue = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return R.reduce(function (acc, val) { return (acc !== undefined ? acc : val); }, undefined, values);
};
exports.slidingPanelLens = R.lensPath(['visualStack', 'slidingPanel']);
exports.slidingPanelActiveLens = R.compose(exports.slidingPanelLens, R.lensPath(['active']));
var InternalSlidingPanel = /** @class */ (function (_super) {
    __extends(InternalSlidingPanel, _super);
    function InternalSlidingPanel(props) {
        var _this = _super.call(this, props) || this;
        if (_this.props.syncStateToOpen) {
            _this.props.setSlidingPanelActiveState(true);
        }
        return _this;
    }
    InternalSlidingPanel.prototype.render = function () {
        var _a = this.props, _b = _a.active, active = _b === void 0 ? false : _b, children = _a.children, restProps = __rest(_a, ["active", "children"]);
        return (react_1["default"].createElement("div", { className: "vs-internal-sliding-panel" },
            react_1["default"].createElement(SlidingPanel_1.SlidingPanel, __assign({ active: active }, restProps), children)));
    };
    return InternalSlidingPanel;
}(react_1.Component));
exports.InternalSlidingPanel = InternalSlidingPanel;
InternalSlidingPanel.propTypes = {
    active: prop_types_1["default"].bool,
    initialActive: prop_types_1["default"].bool,
    children: prop_types_1["default"].any,
    toggleSlidingPanel: prop_types_1["default"].func,
    setSlidingPanelActiveState: prop_types_1["default"].func
};
var slidingPanelStateToProps = function (state, ownProps) {
    var initialActive = ownProps.initialActive;
    var activeState = R.view(exports.slidingPanelActiveLens, state);
    var active = useFirstDefinedValue(activeState, initialActive);
    var syncStateToOpen = !!(activeState === undefined && initialActive);
    return { active: active, syncStateToOpen: syncStateToOpen };
};
exports.slidingPanelStateToProps = slidingPanelStateToProps;
exports.SlidingPanel = (0, react_redux_1.connect)(exports.slidingPanelStateToProps, { toggleSlidingPanel: actions_1.toggleSlidingPanel, setSlidingPanelActiveState: actions_1.setSlidingPanelActiveState })(InternalSlidingPanel);
var InternalToggleIcon = /** @class */ (function (_super) {
    __extends(InternalToggleIcon, _super);
    function InternalToggleIcon(props) {
        var _this = _super.call(this, props) || this;
        var eventSupportsPropagation = R.view(R.lensPath(['nativeEvent', 'stopImmediatePropagation']));
        _this.handleClick = function (e) {
            if (eventSupportsPropagation(e))
                e.nativeEvent.stopImmediatePropagation();
            _this.props.toggleSlidingPanel();
        };
        return _this;
    }
    InternalToggleIcon.prototype.render = function () {
        var _this = this;
        return (react_1["default"].createElement(SlidingPanel_1.ToggleIcon, __assign({}, R.dissoc('toggleSlidingPanel', this.props), { onClick: function (e) { return _this.handleClick(e); } })));
    };
    return InternalToggleIcon;
}(react_1.Component));
exports.InternalToggleIcon = InternalToggleIcon;
InternalToggleIcon.propTypes = {
    toggleSlidingPanel: prop_types_1["default"].func
};
var makeExpandedLens = function (_a) {
    var id = _a.id;
    return R.lensPath([id, 'expanded']);
};
var InternalSlidingPanelDropdown = /** @class */ (function (_super) {
    __extends(InternalSlidingPanelDropdown, _super);
    function InternalSlidingPanelDropdown(props) {
        var _this = _super.call(this, props) || this;
        if (props.syncStateToOpen) {
            _this.props.expandFilterDropdown();
        }
        return _this;
    }
    InternalSlidingPanelDropdown.prototype.render = function () {
        var _a = this.props, children = _a.children, restProps = __rest(_a, ["children"]);
        return (react_1["default"].createElement(SlidingPanel_1.SlidingPanelDropdown, __assign({}, restProps), children));
    };
    return InternalSlidingPanelDropdown;
}(react_1.Component));
exports.InternalSlidingPanelDropdown = InternalSlidingPanelDropdown;
InternalSlidingPanelDropdown.propTypes = {
    slidingPanel: prop_types_1["default"].object,
    id: prop_types_1["default"].string.isRequired,
    initialActive: prop_types_1["default"].bool,
    label: prop_types_1["default"].any,
    badge: prop_types_1["default"].any,
    children: prop_types_1["default"].any,
    toggleFilterDropdown: prop_types_1["default"].func,
    styles: prop_types_1["default"].object,
    expandFilterDropdown: prop_types_1["default"].func,
    hideFilterDropdown: prop_types_1["default"].func
};
var slidingPanelDropdownStateToProps = function (state, ownProps) {
    var initialActive = ownProps.initialActive;
    var expandedState = R.view(R.compose(exports.slidingPanelLens, makeExpandedLens(ownProps)), state);
    var expanded = useFirstDefinedValue(expandedState, initialActive);
    var syncStateToOpen = !!(expandedState === undefined && initialActive);
    return { expanded: expanded, syncStateToOpen: syncStateToOpen };
};
exports.slidingPanelDropdownStateToProps = slidingPanelDropdownStateToProps;
exports.SlidingPanelDropdown = (0, react_redux_1.connect)(exports.slidingPanelDropdownStateToProps, function (dispatch, _a) {
    var id = _a.id;
    return ({
        expandFilterDropdown: function () {
            dispatch((0, actions_1.expandFilterDropdown)(id));
        },
        hideFilterDropdown: function () {
            dispatch((0, actions_1.hideFilterDropdown)(id));
        },
        onClick: function () {
            dispatch((0, actions_1.toggleFilterDropdown)(id));
        }
    });
})(InternalSlidingPanelDropdown);
exports.ToggleIcon = (0, react_redux_1.connect)(function (state) { return ({ toggleIconState: R.view(exports.slidingPanelActiveLens, state) }); }, { toggleSlidingPanel: actions_1.toggleSlidingPanel })(InternalToggleIcon);
exports.SlidingPanelHeader = SlidingPanel_1.SlidingPanelHeader;
exports.SlidingPanelSection = SlidingPanel_1.SlidingPanelSection;
